import * as Tooltip from '@radix-ui/react-tooltip';
import { Icon, Image, Radio } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function ImagePreview({
  src,
  active,
  showActions,
  width,
  onDelete,
  hasPreview = false,
  hasBorder = true,
  isWrapper = false,
  hasRadio = true,
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <S.ImagePreview
            width={width}
            hasBorder={hasBorder}
            isWrapper={isWrapper}
            active={active}
            {...rest}
          >
            <S.ImagePreviewBox>
              <Image src={src} alt={t('imagePreview')} />
            </S.ImagePreviewBox>
            {showActions && (
              <S.DeleteButton
                variant="link"
                onClick={() => {
                  if (onDelete) onDelete();
                }}
              >
                <Icon name="delete" />
              </S.DeleteButton>
            )}
            {hasRadio && (
              <S.RadioButton isActive={active && !showActions}>
                <Radio checked={active} />
              </S.RadioButton>
            )}
          </S.ImagePreview>
        </Tooltip.Trigger>
        {hasPreview && (
          <Tooltip.Portal>
            <Tooltip.Content className="TooltipContent" sideOffset={5} style={{ zIndex: 10000 }}>
              <Image
                src={src}
                alt={t('imagePreview')}
                width={400}
                height={400}
                style={{
                  width: 400,
                  height: 400,
                  borderRadius: 4,
                  border: '1px solid var(--color-border-default)',
                  backgroundColor: 'var(--color-bg-body)',
                  objectFit: 'contain'
                }}
              />
            </Tooltip.Content>
          </Tooltip.Portal>
        )}
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}

export { ImagePreview };

ImagePreview.propTypes = {
  active: PropTypes.bool,
  hasBorder: PropTypes.bool,
  hasPreview: PropTypes.bool,
  isWrapper: PropTypes.bool,
  onDelete: PropTypes.func,
  showActions: PropTypes.bool,
  src: PropTypes.string,
  width: PropTypes.number
};
